import {
  cookieStorageStrategy,
  PersistentStorageStrategyFactory,
} from '@redbubble/persistent-storage';

const resolver = new PersistentStorageStrategyFactory();

resolver.register(cookieStorageStrategy('rbFEP_'));

export const cookieStorage = resolver.getStrategy().storageInstance();
